import _ from 'underscore'
import Vue from 'vue'
import Blog from '../../resources/blog'

// This is an object where ads will be stored
// with keys as the id, and ad as the value
const state = {
}

const getters = {
  allBlogPosts(state) {
    return _.values(state);
  },
}

const actions = {
  getBlogPosts(context) {
    Blog.query({}).then((res) => {
      context.commit(`RETRIEVE_BLOGPOSTS_SUCCESS`, { blogPosts: res.data });
    }, (res) => {
      Toast.error('Failed to retrieve blog posts');
    });
  },

  // payload.ad
  deleteBlogPost(context, payload) {
    Blog.delete({ id: payload.blogPost.id }).then((res) => {
      context.commit(`DELETE_BLOGPOST_SUCCESS`, { blogPost: payload.blogPost });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to delete blog post');
    });
  },

  // payload.id, payload.changes
  updateBlogPost(context, payload) {
    Blog.update({ id: payload.id }, payload.changes).then((res) => {
      context.commit(`UPDATE_BLOGPOST_SUCCESS`, { blogPost: res.data });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to save blog post');
    });
  },

   createBlogPost(context, payload) {
     Blog.save(payload.blogPost).then((res) => {
       context.commit('CREATE_BLOGPOST_SUCCESS', { blogPost: res.data });
       if (_.isFunction(payload.callback)) payload.callback(res.data);
     }, (res) => {
       Toast.error('Failed to create blog post');
     });
   },

}

const mutations = {

  RETRIEVE_BLOGPOSTS_SUCCESS(state, payload) {
    _.each(payload.blogPosts, (post) => {
      Vue.set(state, post.id, post);
    })
  },

  DELETE_BLOGPOST_SUCCESS(state, payload) {
    Vue.delete(state, payload.blogPost.id);
  },

  // payload.ad
  UPDATE_BLOGPOST_SUCCESS(state, payload) {
    Vue.set(state, payload.blogPost.id, payload.blogPost);
  },

  CREATE_BLOGPOST_SUCCESS(state, payload) {
    //Vue.set(state, payload.blogPost.id, payload.blogPost);
  },

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/blogs.js